module.exports = __webpack_public_path__ + "img/subjective-detection_example.51a1c3e8.svg";